import React from "react";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider } from "./context/StoreProvider";

import AnnouncementBar from "./components/layout/AnnouncementBar";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import CartDrawer from "./components/cart/CartDrawer";
import SearchOverlay from "./components/layout/SearchOverlay";
import FloatingWhatsApp from "./components/layout/FloatingWhatsApp";
import ScrollToTop from "./components/layout/ScrollToTop";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Collections from "./pages/Collections";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Wishlist from "./pages/Wishlist";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import SizeGuide from "./pages/SizeGuide";
import Policy from "./pages/Policy";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <StoreProvider>
      <ScrollToTop />
      <AnnouncementBar />
      <Header />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:slug" element={<ProductDetail />} />
          <Route path="/collections" element={<Collections />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/size-guide" element={<SizeGuide />} />
          <Route path="/shipping-policy" element={<Policy type="shipping" />} />
          <Route path="/return-policy" element={<Policy type="returns" />} />
          <Route path="/privacy-policy" element={<Policy type="privacy" />} />
          <Route path="/terms" element={<Policy type="terms" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />

      {/* Global overlays */}
      <CartDrawer />
      <SearchOverlay />
      <FloatingWhatsApp />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            borderRadius: 0,
            border: "1px solid #0A0A0A",
            background: "#0A0A0A",
            color: "#fff",
            fontFamily: "IBM Plex Mono, monospace",
            fontSize: "12px",
            textTransform: "uppercase",
            letterSpacing: "0.1em",
          },
        }}
      />
    </StoreProvider>
  );
}

export default App;
